import * as React from 'react';
const h = React.createElement;
import { icons } from '../icons';
import { DOMModal } from '../confirm';
import { Button } from './Button';

export interface ModalProps {
  title?: React.ReactNode;
  open?: boolean;
  onCancel?: () => void;
  onOk?: () => void;
  footer?: React.ReactNode | null;
  width?: number | string;
  okText?: string;
  cancelText?: string;
  destroyOnClose?: boolean;
  children?: React.ReactNode;
  className?: string;
}

interface ModalComponent extends React.FC<ModalProps> {
  confirm: typeof DOMModal.confirm;
}

const ReactModal: ModalComponent = function Modal(props: ModalProps) {
  const {
    title,
    open,
    onCancel,
    onOk,
    footer,
    width = 520,
    okText = 'OK',
    cancelText = 'Cancel',
    children,
    className = '',
  } = props;

  if (!open) return null;

  const defaultFooter = h(
    'div',
    { className: 'flex justify-end gap-3 pt-4' },
    h(Button, { onClick: onCancel }, cancelText),
    h(Button, { type: 'primary', onClick: onOk }, okText),
  );

  return h(
    'div',
    { className: 'fixed inset-0 z-[9998] flex items-center justify-center p-4' },
    h('div', {
      className: 'fixed inset-0 bg-black/60 backdrop-blur-sm',
      onClick: onCancel,
    }),
    h(
      'div',
      {
        className: `relative bg-dark-800 rounded-xl shadow-2xl border border-dark-700 w-full ${className}`,
        style: { maxWidth: width },
      },
      h(
        'div',
        { className: 'flex items-center justify-between p-6 border-b border-dark-700' },
        h('h3', { className: 'text-lg font-semibold text-white' }, title),
        h(
          'button',
          {
            className: 'text-dark-400 hover:text-white transition-colors',
            onClick: onCancel,
          },
          h(icons.CloseCircleOutlined),
        ),
      ),
      h('div', { className: 'p-6' }, children),
      footer !== null &&
        h('div', { className: 'px-6 pb-6' }, footer === undefined ? defaultFooter : footer),
    ),
  );
} as ModalComponent;

ReactModal.confirm = DOMModal.confirm;

export { ReactModal as Modal };
